module.exports = __webpack_public_path__ + "img/conversation.fbedb8a0.png";